import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MuiModal from '@mui/material/Modal';
import SVGIcon from '../SVGIcon/SVGIcon';
import { StyledModalInternal, StyledCloseButtonWrapper } from './Modal.styles';

/**
 * Modal component is used for Signing in and any othe location a pop up modal is needed
 */
class Modal extends Component {
  static propTypes = {
    /**
     * Background color of the Modal
     */
    bgColor: PropTypes.string,

    /**
     * The Items to appear inside the Modal
     */
    children: PropTypes.node.isRequired,

    /**
     * Prop for passing classname for styling Modal with Styled Components
     */
    className: PropTypes.string,

    /**
     * The close button prop
     */
    closeButton: PropTypes.node,

    /**
     * Function to handle the closing of the modal
     */
    handleClose: PropTypes.func.isRequired,

    /**
     * The Max height of the Desktop Modal
     */
    height: PropTypes.string,

    /**
     * Interaction/analytics hooks
     */
    onRenderedHook: PropTypes.func,

    /**
     * Boolean for if the Modal is open or closed
     */
    open: PropTypes.bool.isRequired,

    /**
     * Prop to hide/show thw close button on the modal
     */
    showClose: PropTypes.bool,

    /**
     * The Max width of the Desktop Modal
     */
    width: PropTypes.string,

    /**
     * Disable Horizontal Scrolling
     */
    disableHorizontalScroll: PropTypes.bool
  };

  static defaultProps = {
    bgColor: '#ffffff',
    className: undefined,
    closeButton: <SVGIcon selectedIcon="closeModal" />,
    height: null,
    onRenderedHook: () => {},
    showClose: true,
    width: null,
    disableHorizontalScroll: false
  };

  constructor(props) {
    super(props);

    this.scrollPos = 0;

    this.disableScroll = this.disableScroll.bind(this);
  }

  componentDidMount() {
    const { open } = this.props;

    this.disableScroll(open);
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    const { open } = this.props;
    if (open !== prevProps.open && open === false) {
      this.disableScroll(false);
    }
  }

  componentWillUnmount() {
    this.disableScroll(false);
  }

  disableScroll(open) {
    if (open) {
      this.scrollPos = window.scrollY || document.documentElement.scrollTop;
      document.body.classList.add('no-scrolling');
      document.body.style.top = `-${this.scrollPos}px`;
    } else {
      document.body.classList.remove('no-scrolling');
      document.body.style.top = ''; // Clear the top style
      window.scrollTo(0, this.scrollPos); // Restore the scroll position
    }
  }

  renderCloseButton() {
    const { handleClose, closeButton, showClose } = this.props;
    return showClose ? (
      <StyledCloseButtonWrapper
        className="modal-close"
        onClick={() => {
          handleClose();
          this.disableScroll(false);
        }}
      >
        {closeButton}
      </StyledCloseButtonWrapper>
    ) : null;
  }

  render() {
    const {
      bgColor,
      width,
      height,
      handleClose,
      open,
      className,
      onRenderedHook,
      children,
      disableHorizontalScroll
    } = this.props;
    return (
      <MuiModal
        onClose={() => {
          handleClose();
          this.disableScroll(false);
        }}
        onRendered={() => {
          onRenderedHook;
          this.disableScroll(true);
        }}
        open={open}
        className={className}
      >
        <StyledModalInternal
          width={width}
          height={height}
          bgColor={bgColor}
          disableHorizontalScroll={disableHorizontalScroll}
        >
          {this.renderCloseButton()}
          {children}
        </StyledModalInternal>
      </MuiModal>
    );
  }
}

export default Modal;
